import * as Yup from "yup";
import i18n from "i18next";

const getConfigSchema = function(){
    return Yup
        .object()
        .shape({
            mailchimpListId: Yup
                .string()
                .required(i18n.t('Choose mailchimp campaign id is required')),
            templateId: Yup
                .number()
                .required(i18n.t('Choose template is required')),
            name: Yup
                .string()
                .test(
                    'name',
                    "Only a-z, A-Z, space char, 0-9 , , . - _ ! @ # $ % & * : ; \" ״ ' | < > ? + = ( ) / \\ ? . , ] [ , min 4 chars, max 70 chars",
                    value => /^[a-zA-Z0-9,.-_!@#$%&*:;"'|<>?+=()/?.,\]\[}{\s]{5,70}$/.test(value),
                )
                .required(i18n.t('Name field is required')),
            mailServiceFields: Yup
                .object()
                .shape({
                    preview: Yup
                        .string()
                        .test(
                            'preview',
                            "Only a-z, A-Z, space char, 0-9 , , . - _ ! @ # $ % & * : ; \" ״ ' | < > ? + = ( ) / \\ ? . , ] [ , min 4 chars, max 70 chars",
                            value => /^[a-zA-Z0-9,.-_!@#$%&*:;"'|<>?+=()/?.,\]\[}{\s]{5,70}$/.test(value),
                        )
                        .required(i18n.t('Preview field is required')),
                    title: Yup
                        .string()
                        .test(
                            'title',
                            "Only a-z, A-Z, space char, 0-9 , , . - _ ! @ # $ % & * : ; \" ״ ' | < > ? + = ( ) / \\ ? . , ] [ , min 4 chars, max 70 chars",
                            value => /^[a-zA-Z0-9,.-_!@#$%&*:;"'|<>?+=()/?.,\]\[}{\s]{5,70}$/.test(value),
                        )
                        .required(i18n.t('Title field is required')),
                    from: Yup
                        .string()
                        .required(i18n.t('From is required')),
                    replayTo: Yup
                        .string()
                        .email(i18n.t('Invalid pattern email'))
                        .required(i18n.t('Replay to is required')),
                    subjectLine: Yup
                        .string()
                        .test(
                            'subjectLine',
                            "Only a-z, A-Z, space char, 0-9 , , . - _ ! @ # $ % & * : ; \" ״ ' | < > ? + = ( ) / \\ ? . , ] [ , min 4 chars, max 70 chars",
                            value => /^[a-zA-Z0-9,.-_!@#$%&*:;"'|<>?+=()/?.,\]\[}{\s]{5,70}$/.test(value),
                        )
                        .required(i18n.t('Subject line is required')),
                })

        });
}

export default getConfigSchema;
